import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { MaterialTopTabBarProps } from '@react-navigation/material-top-tabs';

import { Text, colors, spacing } from '@pletly/ui';

type Props = MaterialTopTabBarProps;

export const TabBar = ({ state, descriptors, navigation }: Props) => {
	return (
		<View style={styles.root}>
			{state.routes.map((route, index) => {
				const { options } = descriptors[route.key];
				const label =
					options.tabBarLabel !== undefined && typeof options.tabBarLabel === 'string'
						? options.tabBarLabel
						: options.title !== undefined
							? options.title
							: route.name;

				const isFocused = state.index === index;

				const onPress = () => {
					const event = navigation.emit({
						type: 'tabPress',
						target: route.key,
						canPreventDefault: true,
					});

					if (!isFocused && !event.defaultPrevented) {
						// The `merge: true` option makes sure that the params inside the tab screen are preserved
						navigation.navigate({ name: route.name, merge: true });
					}
				};

				const onLongPress = () => {
					navigation.emit({
						type: 'tabLongPress',
						target: route.key,
					});
				};

				return (
					<TouchableOpacity
						key={label}
						accessibilityRole="button"
						style={[styles.button, isFocused && styles.activeButton]}
						accessibilityState={isFocused ? { selected: true } : {}}
						accessibilityLabel={options.tabBarAccessibilityLabel}
						testID={options.tabBarTestID}
						onPress={onPress}
						onLongPress={onLongPress}
					>
						<Text category="p2">{label}</Text>
					</TouchableOpacity>
				);
			})}
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		gap: spacing(1),
	},
	button: {
		borderRadius: spacing(),
		paddingVertical: spacing(),
		paddingHorizontal: spacing(2),
		backgroundColor: colors.neutral200,
	},
	activeButton: {
		backgroundColor: colors.primary200,
	},
});
